const faqData = [
    {
        id:"1",
        question : "How can I start my property search with Ligasos?",
        answer :"To begin your property search with Ligasos, simply navigate to our homepage and use our intuitive search tool to browse available properties. You can also contact us directly to speak with one of our representatives who will be happy to assist you.",
    },
    {
        id:"2",
        question : "What types of properties does Ligasos offer?",
        answer :"At Ligasos, we offer a wide range of properties to suit every need, including residential homes, apartments, villas, commercial spaces, and investment properties. Whatever you’re looking for, we have you covered.",
    },
    {
        id:"3",
        question : "How does the rental process work with Ligasos?",
        answer :"Renting a property with Ligasos is easy! Simply browse our available rental listings, schedule viewings for properties you’re interested in, and submit an application. Our team will guide you through the rest of the process, including lease signing and move-in.",
    },
    {
        id:"4",
        question : "What services does Ligasos offer for property sellers?",
        answer :"For property sellers, Ligasos offers comprehensive sales services, including market analysis, property marketing, negotiation, and closing assistance. Our goal is to help you sell your property quickly and for the best possible price.",
    },
    {
        id:"5",
        question : "Can Ligasos help with property management?",
        answer :"Yes, we offer professional property management services for landlords and property owners. Our services include tenant screening, booking collection, property maintenance, and more. We’ll take care of all the details so you can enjoy passive income with peace of mind.",
    },
    {
        id:"6",
        question : "Does Ligasos provide investment consultancy services?",
        answer :"Absolutely! Whether you’re a seasoned investor or new to real estate investing, our investment consultancy services can help you make informed decisions and maximize your returns. We’ll provide expert advice tailored to your specific investment goals.",
    },
    {
        id:"7",
        question : "How accurate are Ligasos' property valuations?",
        answer :"Our property valuations are based on thorough market research, property inspections, and analysis of comparable sales data. While we strive for accuracy, it’s important to keep in mind that valuations are estimates and may vary based on market conditions and other factors.",
    },
    {
        id:"8",
        question : "What legal assistance does Ligasos offer for real estate transactions?",
        answer :"We offer legal assistance services to help clients navigate the legal complexities of real estate transactions. Our team can provide guidance on contracts, negotiations, due diligence, and more to ensure a smooth and legally sound transaction.",
    },
    {
        id:"9",
        question : "How can I get in touch with Ligasos for further assistance?",
        answer :"You can contact us by phone, email, or through the contact form on our website. Our office hours are Monday to Friday, 9:00 AM to 6:00 PM, and Saturday, 10:00 AM to 4:00 PM. We look forward to hearing from you!",
    },
    {
        id:"10",
        question : "What sets Ligasos apart from other real estate agencies?",
        answer :"At Ligasos, we pride ourselves on our personalized approach to real estate. Unlike other agencies, we take the time to truly understand our clients’ needs and tailor our services accordingly. Our team consists of experienced professionals who are dedicated to providing exceptional service and delivering results. Whether you’re buying, selling, renting, or investing, you can trust Ligasos to be your partner every step of the way.",
    },
]

export default faqData;